import {t} from "../../i18n";
import {bindInputListeners, bindPhoneValidation, showValidationErrors} from "../../utils/formHelpers";

export default function bookingPhone({ $, api, state, data, routes, emit, sharedState, onNext, onComplete, onSaveState }) {
    function render() {
        const panelTitle = t(data.isAuth ? 'requestPhoneCheckTitle' : 'requestPhoneNoAccTitle');
        const panelDetails = t(data.isAuth ? 'requestPhoneCheckDetails' : 'requestPhoneNoAccDetails');
        const backButton = data.skipUser ? '' : `<button class="modal-close-button auth-back-btn" data-step="booking-init">X</button>`;
        const $el = $(`
    <div class="booking-step-row active" data-auth-step="booking-phone">
        ${backButton}
        <div class="texts-phone-check-header" >
            <h3 class="text-center">${panelTitle}</h3>
            <p>${panelDetails}</p>
        </div>
        <form class="booking-phone-form">
            <div class="form-row booking-name-input"${data.isAuth ? ' style="display: none"' : ''}>
                <label for="bookingName">${t('full_name')}</label>
                <input type="text" id="bookingName">
                <p class="field-error field-name-error" style="display:none;">
                    ${t('please_enter_a_name')}
                </p>
            </div>
            <div class="form-row">
                <label for="bookingPhone">${t('phone')}</label>
                <input type="tel" inputmode="tel" autocomplete="tel"
                    required="" id="bookingPhone" name="phone" value="${sharedState.phone || ''}">
                <p class="field-error field-phone-incorrect-error" style="display:none;">
                    ${t('form.phone_number_not_found')}
                </p>
                <p class="field-error field-phone-ro-error" style="display:none;">
                    ${t('form.please_enter_a_valid_number')}
                </p>
                <p class="field-error field-phone-length-error" style="display:none;">
                    ${t('form.phone_number_must_have_at_least_n_digits', {count: 10})}
                </p>
            </div>
            <div class="form-actions">
                <button type="submit">${data.skipValidate ? t('continue') : t('send_sms')}</button>
            </div>
        </form>
    </div>
        `);

        $el.on('submit', '.booking-phone-form', e => {
            e.preventDefault();

            let phone = $("#bookingPhone").val().trim();
            phone = phone.replace(/[^\d+]/g, '');

            if(sharedState.noAccount) {
                const $nameInput = $('#bookingName');
                const bookingName = $nameInput.val().trim();

                // If the input is visible and empty, show error and abort submission
                if ($nameInput.is(':visible')) {
                    const $nameError = $el.find('.field-name-error');
                    const minNameLength = 3;
                    if (!bookingName || bookingName.length < minNameLength) {
                        if(bookingName && bookingName.length < minNameLength) {
                            $nameError.text(t('please_enter_a_valid_name_min_chars', {count: minNameLength}));
                        }
                        $nameError.show();
                        $nameInput.addClass('input-error');
                        return;
                    } else {
                        $nameError.hide();
                        $nameInput.removeClass('input-error');
                    }
                }

                state.bookingName = bookingName;

                if(data.skipValidate) {
                    onComplete({user: {name: bookingName, phone: phone}});
                } else {
                    getCode($el, routes.generateCode, { phone });
                }
            } else {
                let email = sharedState.email;
                getCode($el, routes.validatePhone, { phone, email });
            }

            sharedState.phone = phone;
            onNext('booking-sms');
        });

        bindInputListeners($el);

        const $phoneInput = $el.find('input[name="phone"]');

        bindPhoneValidation($phoneInput, {
            isInternational: true,
            onValidChange: (isValid) => {
                $el.find('button[type="submit"]').prop('disabled', !isValid);
            }
        });

        return $el;
    }

    function getCode($el, url, param) {
        api.post(url, {
            data: param,
            success: (data) => {
                onNext('booking-sms');
            },
            error: (err) => {
                console.warn('Failed:', err);
                showValidationErrors($el, err.data.errors || {});
            }
        })
    }

    return { render }
}